/**
 * create formatted search request object
 * @param {string} vehicleId
 * @param {string} accountId
 * @returns {object} formatted search request object
 */
export const getSearchRO = (vehicleId, accountId) => {
	return {
		vehicleIncentives: {
			accountId,
			uuid: vehicleId
		}
	};
};

export function getSiteId(rData) {
	return (rData.parameterMap && rData.parameterMap.siteId) || rData.siteId;
}

export function getDeviceType(rData) {
	return (
		(rData.parameterMap && rData.parameterMap.deviceType) ||
		rData.deviceType
	);
}

export function getIncentivesCap(rData) {
	const incentivesCap =
		(rData.parameterMap && rData.parameterMap.incentivesCap) || -1;
	return Number.isNaN(Number(incentivesCap)) ? -1 : Number(incentivesCap);
}

export function getAccountId(rData) {
	return (
		(rData.parameterMap && rData.parameterMap.accountId) || rData.accountId
	);
}

// Return only the categories specified by preferences
export function filterIncentives(incentives, prefs) {
	const filteredIncentives = [];

	incentives.forEach(incentive => {
		const creator = incentive.manufacturerOffer ? 'oem' : 'dealer';
		const type = incentive.conditional ? 'conditional' : 'regular';
		if (
			(creator === 'oem' &&
				type === 'regular' &&
				prefs.showOemNationalIncentives === 'true') ||
			(creator === 'oem' &&
				type === 'conditional' &&
				prefs.showOemConditionalIncentives === 'true') ||
			(creator === 'dealer' &&
				type === 'regular' &&
				prefs.showDealerRegularIncentives === 'true') ||
			(creator === 'dealer' &&
				type === 'conditional' &&
				prefs.showDealerConditionalIncentives === 'true')
		) {
			filteredIncentives.push(incentive);
		}
	});

	return filteredIncentives;
}

// Return object containing incentives broken out by category
export function categorizeIncentives(incentives) {
	const categorizedIncentives = {
		oem: {
			regular: [],
			conditional: []
		},
		dealer: {
			regular: [],
			conditional: []
		}
	};

	incentives.forEach(incentive => {
		const creator = incentive.manufacturerOffer ? 'oem' : 'dealer';
		const type = incentive.conditional ? 'conditional' : 'regular';

		categorizedIncentives[creator][type].push(incentive);
	});

	return categorizedIncentives;
}



// WEBPACK FOOTER //
// ./src/utils/utility.js